import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { useHistory } from "react-router-dom";
import TabPanel from "../../elements/tab/materialTabPanel";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ConnectedServicesList from "./ConnectedServicesList";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from "../../styles/styledTabs";
import { removeTransferFromCollection } from "../../../utils/collections";

const ConnectedServicesContainer = () => {
  const { t } = useTranslation("connectionServicesPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const [projects, setProjects] = useState(null);

  useEffect(() => {
    axios.get("/api/projects", userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProjects(removeTransferFromCollection(response.data["hydra:member"]));
      }
    }).catch(() => {

    });
  }, []);


  const urlForTabs = () => {
    if (!queryParams.currentTab || !projects) {
      return 0;
    }

    const projectIndex = projects.findIndex(item => item.name === queryParams.currentTab);

    return projectIndex !== -1 ? projectIndex : 0;
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  if (!projects) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  const renderProject = (content) => {
    return (
      projects && projects.map((item, key) => (
        content === "tabs" ?
          <Tab
            key={key}
            label={item.name}
            value={item.name}
          /> :
          <TabPanel
            key={key}
            index={key}
            value={tabValue}
          >
            <ConnectedServicesList project={item} />
          </TabPanel>
      )));
  };

  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs
            value={queryParams?.currentTab ?? projects[0]?.name}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="vertical"
            className="tab-head-buttons"
          >
            {renderProject("tabs")}
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          {renderProject("tabPanel")}
        </StyledTabsBody>
      </StyledTabsWrapper>
    </>
  );
};
export default ConnectedServicesContainer;

